import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import React, { lazy, useMemo, useState } from 'react';
import DataUsageFilters from './DateUsageFilters';
import Filters from './Filters';

import { imageUrls } from '@/config/constants/keys';
import { UI_DATE_FORMAT_WITH_TIME_24 } from '@/config/constants/static';
import { getImagePath, objectIntoArray } from '@/utils/utils';
import { Link as LinkLi } from '@material-ui/core';
import moment from 'moment';
import VideoJS from '../Vehicles/videoComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;

const Breadcrumb = lazy(() => import(`../../../components/Breadcrumb`));
const Icon = lazy(() => import(`@/components/UI/Icon/${layout}`));
const Tab = lazy(() => import(`@/components/UI/Tab/${layout}`));
const Table = lazy(() => import(`@/components/UI/Table/${layout}`));
const Message = lazy(() => import(`@/components/UI/Message/${layout}`));
const Modal = require(`@/components/UI/Modal/${layout}`).default;

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const Component = ({
  fetchVideoUrl,
  callback,
  eventsData,
  dataUsageList,
  Styled,
  changeEventType,
  changeDataUsageFilter,
  changeDataUsageRequest,
  dataUsageRequest,
  i18n,
  history,
  pagination,
  changeRequest,
  request,
  paramsList,
  vehicleList,
  eventTypes: eventList,
  setPagination }) => {
  const eventTypes = useMemo(() => {
    return objectIntoArray(eventList);
  }, [eventList]);
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [cameraModalList, setCameraModalList] = useState({
    header: '',
    content: () => (
      <video width="720" height="445" id="video" controls></video>
    )
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dataUsageColumns = [
    {
      id: 'vehicle',
      numeric: false,
      disablePadding: true,
      label: i18n.t('camera.vehicle'),
      needSorting: true
    },
    {
      id: 'camera_serial_no',
      numeric: false,
      disablePadding: true,
      label: i18n.t('camera.camera_serial_no'),
      needSorting: true
    },
    {
      id: 'data_usage',
      numeric: false,
      disablePadding: true,
      label: i18n.t('camera.tabs.dataUsage'),
      needSorting: true
    },
    {
      id: 'cycle',
      numeric: false,
      disablePadding: true,
      label: i18n.t('camera.cycle'),
      needSorting: true
    },
  ]
  const columns = [
    {
      id: 'vehicle',
      numeric: false,
      disablePadding: true,
      label: i18n.t('camera.vehicle'),
      needSorting: true
    },
    {
      id: 'camera_serial_no',
      numeric: true,
      disablePadding: false,
      label: i18n.t('camera.camera_serial_no'),
      needSorting: true
    },
    {
      id: 'event_type',
      numeric: false,
      disablePadding: false,
      label: i18n.t('camera.event_type'),
      needSorting: true
    },
    // TODO Removed Camera_View
    // {
    //   id: 'camera_view',
    //   numeric: false,
    //   disablePadding: false,
    //   label: i18n.t('camera.camera_view'),
    //   needSorting: false
    // },
    {
      id: 'event_level',
      numeric: true,
      disablePadding: false,
      label: i18n.t('camera.event_level'),
      needSorting: true
    },
    {
      id: 'date',
      numeric: false,
      disablePadding: false,
      label: i18n.t('camera.date'),
      needSorting: true
    },
    // removed to view dateTime
    // {
    //   id: 'time',
    //   numeric: false,
    //   disablePadding: false,
    //   label: i18n.t('camera.time'),
    //   needSorting: true
    // },
    {
      id: 'actions',
      label: i18n.t('Actions')
    }
  ];
  const generateRows = () => {
    return eventsData.data ? eventsData?.data?.map(el => { return {...el, camera_view: 360, date: moment.utc(parseFloat(el?.start_time))?.local().format(UI_DATE_FORMAT_WITH_TIME_24)}}) : [];
  };
  const generateDataUsageRows = () => {
    return dataUsageList.data ? dataUsageList.data : []
  }
  const intialData = {
    eventType: null,
    ...(paramsList ? paramsList : {}),
  };


  const [values, setInitialValues] = useState(intialData);

  const [dataUsageValues, setDataUsageInitialValues] = useState({
    startDate: null,
    endDate: null
  });

  const information = i18n.t('common.tableEmptyMessage');

  const isEventOld = (eventDate, eventTime) => {
    const eventDateTime = moment(`${eventDate}T${eventTime}Z`);
    const sixMonthsAgo = moment().subtract(6, 'months');
    const isOld = eventDateTime.isBefore(sixMonthsAgo);
    return isOld;
  }

  const tabValues = [
    {
      name: i18n.t('camera.tabs.events'),
      value: (
        <Styled.TableWrapper>
          <Filters
            fleetCompanyList={eventTypes}
            filterList={(data) => {
              changeEventType(data)
            }}
            vehicleList={vehicleList}
            handleReset={() => {
              changeEventType({ eventType: '' })
            }}
            values={values}
            setInitialValues={setInitialValues}
          />
          <Table
            type="server"
            defaultSortBy={{ sortBy: 'vehicle', order: 'asc' }}
            title=""
            history={history}
            changeRequest={changeRequest}
            baseRequest={request}
            totalRecords={eventsData.total}
            columns={[...columns]}
            data={generateRows()}
            emptyMessage={information}
            itemsPerPage={10}
            actions={[
              {
                icon: (row) => {
                  return (
                    <LinkLi
                      className="normalLink" onClick={() => {
                        const callbackFunction = (videoUrl) => {
                          setOpen(true)
                          setCameraModalList({
                            header: '',
                            content: () => {
                              return (
                              <div>
                                <VideoJS options={{
                                  autoplay: true,
                                  controls: true,
                                  responsive: true,
                                  cameraType: row?.camera_type || '',
                                  fluid: true,
                                  aspectRatio: '16:8',
                                  preload: 'auto',
                                  sources: [{
                                    src: videoUrl,
                                    type: 'video/mp4'
                                  }]
                                }} />
                              </div>
                            )}
                        })
                        }
                        fetchVideoUrl({
                          apiId: 'videoUrlAPI', 
                          data: {
                            clipID: row?.clip_id,
                            isOld: isEventOld(row?.date, row?.time)
                          },
                          callbackFirst: callbackFunction,
                          callbackSecond: callback,
                        })
                      }}
                    >
                      <Icon src={getImagePath(imageUrls.viewMoreIcon)} tooltip={'View'} />
                    </LinkLi>
                  );
                }
              },
              {
                icon: (row) => {
                  return (
                    <LinkLi className="normalLink" onClick={() => {
                      const callbackFunction = (urlVideo) => {
                        let xhr = new XMLHttpRequest();
                        xhr.open('GET', urlVideo, true);
                        xhr.responseType = 'blob';
                        xhr.onload = function () {
                          let urlCreator = window.URL || window.webkitURL;
                          let videoUrl = urlCreator.createObjectURL(this.response);
                          let tag = document.createElement('a');
                          tag.href = videoUrl;
                          tag.target = '_blank';
                          tag.download = 'file.mp4';
                          document.body.appendChild(tag);
                          tag.click();
                          document.body.removeChild(tag);
                        };
                        xhr.onerror = (err) => { };
                        xhr.send();
                      }
                      fetchVideoUrl({
                        apiId: 'videoUrlAPI', 
                        data: {
                          clipID: row?.clip_id,
                          isOld: isEventOld(row?.date, row?.time)
                        },
                        callbackFirst: callbackFunction,
                        callbackSecond: callback,
                      })
                    }} ><Icon src={getImagePath(imageUrls.downloadIcon)} tooltip="Download" /></LinkLi>

                  );
                }
              }
            ]}
            defaultSort={'full_name'}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
        </Styled.TableWrapper>
      )
    },
    {
      name: i18n.t('camera.tabs.dataUsage'),
      value: (
        <Styled.TableWrapper>
          <DataUsageFilters
            fleetCompanyList={eventTypes}
            filterList={(data) => {
              changeDataUsageFilter(data)
            }}
            handleReset={() => {
              changeDataUsageFilter({ startDate: '', endDate: '' })
            }}
            values={dataUsageValues}
            setInitialValues={setDataUsageInitialValues}
          />
          <Table
            type="server"
            defaultSortBy={{ sortBy: 'vehicle', order: 'asc' }}
            totalRecords={dataUsageList.total}
            title=""
            changeRequest={changeDataUsageRequest}
            baseRequest={dataUsageRequest}
            columns={[...dataUsageColumns]}
            data={generateDataUsageRows()}
            emptyMessage={information}
            itemsPerPage={10}
            actions={[]}
            defaultSort={'vehicle'}
            i18n={i18n}
            pageinationReset={pagination}
            pagenationClicked={(e) => {
              setPagination(!e);
            }}
          />
          <Modal
            open={open}
            setOpen={setOpen}
            data={cameraModalList}
            width={'760px'}
            withCloseIcon
            alignItemsLeft
            removeTopSpace
          />
        </Styled.TableWrapper>
      )
    }
  ];
  return (
    <>
      <Styled.Wrapper>
        <Styled.BottomWrapper>
          <Tab
            data={tabValues}
            currentTab={value}
            onChange={handleChange}
            className="cameraTabs"
          />
        </Styled.BottomWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  callback: PropTypes.func.isRequired,
  vehicles: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
};
